import { makeAutoObservable } from 'mobx'

import { validateFieldResponse } from '../utils/validateFieldResponse'
import FieldModel from './FieldModel/FieldModel'
import GOFResponseModel from './GOFResponseModel'

class FieldResponseModel<
   TFieldType extends string,
   TResponse,
   TFieldModel extends FieldModel<TResponse, TFieldType>
> {
   readonly fieldResponseId: string

   response: TResponse
   private _dirtyResponse: TResponse

   field: TFieldModel

   gofResponse?: GOFResponseModel

   private _errorMsg: string | null | undefined
   isValid!: boolean

   constructor(
      fieldResponseId: string,
      response: TResponse,
      fieldModel: TFieldModel,
      gofResponse?: GOFResponseModel
   ) {
      this.fieldResponseId = fieldResponseId
      this.gofResponse = gofResponse

      this.response = response
      this._dirtyResponse = response
      this.field = fieldModel

      makeAutoObservable(this, {}, { autoBind: true })
   }

   get errorMsg(): string | null | undefined {
      return this._errorMsg
   }

   get fieldType(): TFieldType {
      return this.field.fieldType
   }

   setErrorMessage(errorMessage: string | undefined | null) {
      this._errorMsg = errorMessage
   }

   setResponse = (response: TResponse) => {
      this.response = response
      this._dirtyResponse = response

      this.isValid = true
      this.setErrorMessage(null)
   }

   setGOFResponse = (gofResponse: GOFResponseModel) => {
      this.gofResponse = gofResponse
   }

   setDirtyResponse = (response: TResponse) => {
      this._dirtyResponse = response
   }

   get dirtyResponse(): TResponse {
      return this._dirtyResponse
   }

   setError = (errorMsg: string) => {
      this.isValid = false
      this._errorMsg = errorMsg
   }

   resetError = () => {
      this.isValid = true
      this._errorMsg = null
   }

   validate = (
      fieldResponse: TResponse = this.response,
      required: boolean | null | undefined = this.field.required
   ): void => {
      const { validate } = validateFieldResponse()
      const { isValid, errorMessage } = validate(
         fieldResponse as any,
         this.fieldResponseId,
         this.field as any,
         required
      )

      this.isValid = isValid
      this.setErrorMessage(errorMessage)
   }
}

export default FieldResponseModel
